import { makeStyles } from '@mui/styles';
import { COLORS } from 'theme/MainTheme';
import { Theme } from '@mui/material';

export default makeStyles((theme: Theme) => ({
  calendarContainer: {
    '&.MuiGrid-item': {
      [theme.breakpoints.down('md')]: {
        paddingTop: 10,
        width: '100%',
      },
    },
  },
  container: {
    marginTop: 0,

    [theme.breakpoints.down('md')]: {
      padding: 5,
    },
  },
  day: {
    borderBottom: `solid 1px ${COLORS.LIGHT_GREY}`,
    color: COLORS.BLUE,
    fontSize: 20,
    fontWeight: 'bold',
    padding: '32px 20px',
    textAlign: 'center',
    textTransform: 'capitalize',
  },
  dayContainer: {
    '&.MuiGrid-item': {
      [theme.breakpoints.down('md')]: {
        paddingTop: 10,
        width: '100%',
      },
    },
  },
  dayContentContainer: {
    borderRadius: 16,
    boxShadow: '2px 3px 10px 3px rgb(0 0 0 / 16%)',
    height: '100%',
    position: 'relative',
  },
}));
